module.exports = __webpack_public_path__ + "fonts/HMpangram-Medium.44977b3f.ttf";